import { render, staticRenderFns } from "./RecordCheck.vue?vue&type=template&id=022f9366&"
import script from "./RecordCheck.vue?vue&type=script&lang=js&"
export * from "./RecordCheck.vue?vue&type=script&lang=js&"
import style0 from "./RecordCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports